<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>普通报账使用说明:<br>
					<span>1、单号构成规则:201201+PT+4位顺序号。系统生成,添加无效</span><br>
					<span>2、提交后递交给财务审核。</span><br>
					<span class="red">3、业务情景，不是个人费用报销，不是业务流程报销的其他报销和入账情景</span><br>
					<span>4、查询关键字:单号、经办人、收款人、更新日期。</span><br>
				</h5>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<!-- <template slot="pre_tan_button">
				<button @click="edit_mode">库存更新</button>
			</template>
 -->
		</pre-base>


	</div>
</template>

<script>
	import {
		GetShort
	} from '@/utils/localstore.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';

				this.init_data = JSON.stringify({
					"control": "ptbz",
					"title": "普通报账",
					"isTwo": "1",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "1",
					"sel_action": 'exp_cw_pt_m',
					"upd_action": 'exp15_cw_pt_m',
					"detail_part": "1",
					"detail_excelup": "1",
					"d_btn_more": "0",
					"d_sel_action": 'exp_cw_pt_d',
					"d_upd_action": '_cw_pt_d',
					"file_action": 'pt_m',
					"p1": 'caiwu',
					"p2": 'putong',
					"p3": '',
					"parm_sel": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "申请人",
							"val": "",
							"key": "u_name",
							"type": "text",
							"class": "long1",
							"sel": "2"
						},
						{
							"name": "收款人",
							"val": "",
							"key": "rec_user",
							"type": "text",
							"class": "long1",
							"sel": "3"
						},
						{
							"name": "更新日期",
							"val": "",
							"key": "sdate",
							"type": "date",
							"class": "long1",
							"sel": "4"
						}
					],
					"parm": [
						{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "经办人",
							"val": "",
							"key": "u_2name",
							"type": "select",
							"class": "long1",
							"sel_action": "data_alluser",
							"sel_name": "",
							"sel_val": {},
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "收入",
							"val": "",
							"key": "amount_in",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "2"
						},
						{
							"name": "支出",
							"val": "",
							"key": "amount_out",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "2"
						},
						{
							"name": "预支",
							"val": "",
							"key": "amount_bef",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "2"
						},
						{
							"name": "报账合计",
							"val": "",
							"key": "amount",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "2"
						},

						{
							"name": "收款人",
							"val": "",
							"key": "rec_user",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "3"
						},
						{
							"name": "收款人账号",
							"val": "",
							"key": "rec_card",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "3"
						},
						{
							"name": "备注",
							"val": "",
							"key": "p_note",
							"type": "text",
							"class": "long4",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "经办人"
						},
						{
							"name": "部门"
						},
						{
							"name": "收入"
						},
						{
							"name": "支出"
						},
						{
							"name": "预支付"
						},
						{
							"name": "收款人"
						},
						{
							"name": "收款人账号"
						},
						{
							"name": "备注",
							"class": "long2"
						},
						{
							"name": "附件"
						},
						{
							"name": "修改人"
						},
						{
							"name": "浏览地址"
						},
						{
							"name": "存储地址"
						},
						{
							"name": "修改时间"
						}
					],
					"d_parm": [{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "费用名称",
							"val": "",
							"key": "pay_name",
							"type": "select",
							"class": "long1",
							"sel_action": "data_base_bxyz",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "金额",
							"val": "",
							"key": "pay_amount",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "油卡卡号",
							"val": "",
							"key": "pay_no",
							"type": "text",
							"class": "long1",
							"note": "油卡消费必填",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "支付日期",
							"val": "",
							"key": "pay_date",
							"type": "date",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "支付类型",
							"val": "支出",
							"key": "pay_io",
							"type": "select",
							"list": [{
									"id": "1",
									"val": "收入"
								},
								{
									"id": "2",
									"val": "支出"
								}
							],
							"sel_name": "",
							"sel_val": {},
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "是否开票",
							"val": "",
							"key": "is_paper",
							"type": "select",
							"list": [{
								"id": "1",
								"val": "否"
							}, {
								"id": "2",
								"val": "是"
							}],
							"sel_name": "",
							"note": "否",
							"class": "long1",
							"p": "1",
							"w": "0"
						},
						{
							"name": "公司支付",
							"val": "否",
							"key": "is_pay",
							"type": "select",
							"list": [{
								"id": "1",
								"val": "否"
							}, {
								"id": "2",
								"val": "是"
							}],
							"sel_name": "",
							"note": "否",
							"class": "long1",
							"p": "1",
							"w": "0"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						}
					],
					"d_name": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "费用名称"
						},
						{
							"name": "金额"
						},
						{
							"name": "卡号"
						},
						{
							"name": "支付日期"
						},
						{
							"name": "支付|收入"
						},
						{
							"name": "是否开票"
						},
						{
							"name": "公司已支付"
						},
						{
							"name": "备注",
							"class": "long2"
						},

						{
							"name": "修改人",
							"class": "short0"
						},
						// {
						// 	"name": "路径1"
						// },
						// {
						// 	"name": "路径2"
						// },
						{
							"name": "更新时间",
							"class": "long2"
						}
					]

				});


			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			}




		}
	};
</script>
<style>
</style>